import { render, staticRenderFns } from "./AppMobileI18nConfigScreen.vue?vue&type=template&id=38f75eb6&scoped=true&"
import script from "./AppMobileI18nConfigScreen.vue?vue&type=script&lang=js&"
export * from "./AppMobileI18nConfigScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f75eb6",
  null
  
)

export default component.exports